require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./digital-realities-what-is-ar.json") })
        }
      }, "path---digital-realities-what-is-ar");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---digital-realities-what-is-ar!./.cache/json/digital-realities-what-is-ar.json
// module id = 394
// module chunks = 231608221292675